export default {
    'GeneralInfo':"fv--file-tab-paddle",
    'GeneralPrefs':"fv--file-tab-paddle",
    'AddFileAttachment':"fv--comment-tab-paddle",
    'ExtractPages':'fv--organize-tab-paddle',
    'ReplacePages':'fv--organize-tab-paddle',
    'DeletePages':'fv--organize-tab-paddle',
    'CropPages':'fv--organize-tab-paddle',
    'RotatePages':'fv--organize-tab-paddle',
    'Annots:Tool:InkMenuItem':"fv--comment-tab-paddle",
    'SaveAs':"fv--file-tab-paddle",
}